import jQuery from "jquery";
import { ElementSizeToCssVar } from "./element-size-to-css-var";
import { MarkScrollableTabs } from "./mark-scrollable-tabs";
import { PhotoSwipeGallery } from "./photoswipe-gallery";
import { initProductCategoriesSwiper } from "./product-categories-swiper";

function bindProductSearchDesktopAndMobile() {
  const productSearchMobile = document.querySelector(
    ".product-search-mobile .search-field"
  );
  const productSearchDesktop = document.querySelector(
    ".product-search-desktop .search-field"
  );
  if (productSearchMobile && productSearchDesktop) {
    productSearchMobile.addEventListener("input", (event) => {
      const value = event.target.value;
      productSearchDesktop.value = value;
    });
    productSearchDesktop.addEventListener("input", (event) => {
      const value = event.target.value;
      productSearchMobile.value = value;
    });
  }
}

jQuery(function () {
  const topBarWidget = document.querySelector(".top-bar-widget");
  if (topBarWidget) {
    new ElementSizeToCssVar({
      height: "--top-bar-widget-height",
      root: true,
    }).register(topBarWidget);
  }
  const header = document.querySelector("#masthead");
  if (header) {
    new ElementSizeToCssVar({
      height: "--top-header-height",
      root: true,
    }).register(header);
  }

  const productCategoriesTabs = document.getElementById(
    "wpcb-product-categories"
  );
  if (productCategoriesTabs) {
    const scrollableTabs = new MarkScrollableTabs();
    scrollableTabs
      .register(productCategoriesTabs)
      .scrollSelectedIntoView(false);
  }
  bindProductSearchDesktopAndMobile();

  const singleProductTabs = document.getElementById("single-product-wc-tabs");
  if (singleProductTabs) {
    const scrollableTabs = new MarkScrollableTabs();
    scrollableTabs.register(singleProductTabs).scrollSelectedIntoView(false);
  }

  const photoSwipeGallery = new PhotoSwipeGallery();
  photoSwipeGallery.register(".photoswipe-gallery");
  initProductCategoriesSwiper();

  document.querySelectorAll("[data-onload").forEach((el) => {
    switch(el.tagName.toLocaleLowerCase()){
      case "img": {
        el.addEventListener("load", function () {
          this.width = this.naturalWidth;
          this.height = this.naturalHeight;
        });
      }
      case "link": {
        if(el.media!='all'){
          el.media='all'
        }
      }
      default:
    }
  });
});
